/* ============================================================
   Auralis landing — interacciones + trigger Releasit COD.
   Cargado por layout/landing.liquid (case 'auralis').
   Las marquees, el track horizontal de videos y las columnas
   verticales son animaciones CSS puras (keyframes en page-auralis.css);
   aquí solo va lo que necesita JS: galería cliqueable, selector de
   color, selección de bundle y el disparo del modal Releasit.
   ============================================================ */

/* Hero gallery — clic en thumbnail cambia la imagen principal */
(function () {
  var main = document.querySelector('.xs-gal__main img');
  var thumbs = document.querySelectorAll('.xs-gal__thumb');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('src');
      if (src) main.setAttribute('src', src);
      thumbs.forEach(function (t) { t.classList.remove('xs-gal__thumb--active'); });
      thumb.classList.add('xs-gal__thumb--active');
    });
  });
})();

/* Selector de color (solo visual) */
(function () {
  var sw = document.querySelectorAll('.xs-colors__sw');
  if (!sw.length) return;
  sw.forEach(function (s) {
    s.addEventListener('click', function () {
      sw.forEach(function (x) { x.classList.remove('xs-colors__sw--active'); });
      s.classList.add('xs-colors__sw--active');
    });
  });
})();

/* Sticky mobile buy bar — aparece tras scrollear más allá del hero (CSS lo oculta en desktop) */
(function () {
  var bar = document.getElementById('xs-sticky');
  if (!bar) return;
  var hero = document.querySelector('.xs-hero');
  function onScroll() {
    var bottom = hero ? hero.getBoundingClientRect().bottom : 500;
    if (bottom < 0) { bar.classList.add('xs-sticky--show'); }
    else { bar.classList.remove('xs-sticky--show'); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  // Sincroniza el precio de la barra con el bundle seleccionado
  var priceEl = document.getElementById('xs-sticky-price');
  document.querySelectorAll('.xs-bundle').forEach(function (b) {
    b.addEventListener('click', function () {
      var p = b.querySelector('.xs-bundle__pr b');
      if (p && priceEl) priceEl.textContent = p.textContent.trim();
    });
  });
})();

/* ============================================================
   Releasit COD trigger — patrón canónico (memory/project_bundles_as_variants).
   NO usar _rsiV2.setState como primer path: no re-lee la variante tras cambiarla.
   El click nativo del botón Releasit SÍ re-lee window.productData.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  // Variante seleccionada — fuente de verdad en JS (no re-consultamos el DOM al disparar).
  var selectedVariantId = null;

  function setVariantOnAllForms(variantId) {
    if (!variantId) return;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
      input.value = variantId;
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
      input.value = variantId;
    });
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  // Selección de bundle: en CADA click guardamos el id y sincronizamos la variante
  // de inmediato (no esperamos al botón comprar). Esto evita el bug "siempre muestra
  // el precio del bundle activo por defecto" cuando Releasit lee la variante al abrir.
  function selectBundle(label) {
    var id = label.getAttribute('data-bundle-variant-id');
    if (!id) return;
    document.querySelectorAll('.xs-bundle').forEach(function (x) { x.classList.remove('xs-bundle--active'); });
    label.classList.add('xs-bundle--active');
    selectedVariantId = id;
    setVariantOnAllForms(id);
  }

  var bundles = document.querySelectorAll('.xs-bundle[data-bundle-variant-id]');
  bundles.forEach(function (label) {
    label.addEventListener('click', function () { selectBundle(label); });
  });

  // Init: tomar el bundle marcado activo (o el primero) como variante inicial.
  (function initSelected() {
    var active = document.querySelector('.xs-bundle--active[data-bundle-variant-id]') || bundles[0];
    if (active) {
      selectedVariantId = active.getAttribute('data-bundle-variant-id');
      setVariantOnAllForms(selectedVariantId);
    }
  })();

  window.auralisTriggerCOD = function (btn) {
    // Prioridad: id propio del botón (si lo tuviera) > variante seleccionada en el selector.
    var variantId = (btn && btn.getAttribute && btn.getAttribute('data-bundle-variant-id')) || selectedVariantId;
    if (variantId) setVariantOnAllForms(variantId);
    setTimeout(function () {
      var releasitBtn = findReleasitButton();
      if (releasitBtn) { releasitBtn.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
